/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_ErrorInputs */

const en_us2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the report.`)
};

const pt_br2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar o relatório.`)
};

const es_419_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el informe.`)
};

const pt_pt2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o relatório.`)
};

const fr_fr2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger le bilan.`)
};

const de_de2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bericht konnte nicht geladen werden.`)
};

const it_it2_progress_report_error = /** @type {(inputs: Progress_Report_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il report.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the report." |
*
* @param {Progress_Report_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_error = /** @type {((inputs?: Progress_Report_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_error(inputs)
	if (locale === "es-419") return es_419_progress_report_error(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_error(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_error(inputs)
	if (locale === "de-DE") return de_de2_progress_report_error(inputs)
	if (locale === "it-IT") return it_it2_progress_report_error(inputs)
	return en_us2_progress_report_error(inputs)
});
export { progress_report_error as "progress-report.error" }